import * as React from "react";
import * as Modal from "react-modal";
import PhoneInput from "react-phone-input-2";
import { Errors } from "../../libs/i18n/messages";
import { formatterPhone } from "../../libs/helpers/Utils";
import { validateTelephone } from "../validation/validate";
import { COUNTRIES_CODE } from "../../libs/constants";

import Alert from "../../libs/controls/components/Alert";

import "react-phone-input-2/lib/style.css";

const CommentModalState = {
	open: false,
	form: {
		sender_name: null,
		sender_email: null,
		sender_position: null,
		sender_phone: null,
		accept: false,
		comment: null,
	},
	error: [],
	modal: {
		personal: false,
		comment: false,
	},
	title: "",
	pdErrors: null,
};
// TODO: Type -> move to folder Types
export type PdErrors = {
	comment: string[];
	pd_name: string[];
	pd_email: string[];
	pd_phone: string[];
	pd_position: string[];
};

interface Props {
	func: any;
	data: any;
	isFetching: boolean;
	pd_field_errors?: PdErrors;
}

interface State {
	open: boolean;
	form: typeof CommentModalState.form;
	error?: any[];
	modal: any;
	title?: string;
	pdErrors?: PdErrors;
}

interface DrawErrorsProps {
	fields?: Array<string>;
}

const DrawErrors = ({ fields }: DrawErrorsProps) => (
	<div>
		{fields?.map((error) => (
			<Alert key={error}>{error}</Alert>
		))}
	</div>
);

// TODO: В дальнейшем брать поля из шаблонов
class CommentModal extends React.Component<Props, State> {
	state = {
		...CommentModalState,
	};

	componentDidMount() {
		const { pd_field_errors } = this.props;
		this.setState({ pdErrors: pd_field_errors });
	}

	componentDidUpdate(prevProps: Readonly<Props>): void {
		const { pd_field_errors } = this.props;
		if (prevProps.pd_field_errors !== pd_field_errors) {
			this.setState({ pdErrors: pd_field_errors });
		}
	}

	setPhoneState = (field: string) => (value, object, event, valuePhone) => {
		this.setState((prevState) => ({
			form: {
				...prevState.form,
				[field]: formatterPhone(valuePhone),
			},
		}));
	};

	onClose = () => {
		this.setState({ ...CommentModalState });
	};

	onOK = () => {
		const { modal, form } = this.state;
		const { data, func } = this.props;
		const { userRole, status } = data;
		let error = [];

		Object.keys(form).forEach((key) => {
			if (key === "comment") {
				if (modal.comment && !form[key]) {
					error = [...error, "comment"];
				} else if (modal.comment && form[key].length < 50 && userRole === "user" && status === 18) {
					error = [...error, "comment-minlength"];
				}
			} else if (modal.personal) {
				if (!form[key]) {
					error = [...error, key];
				}
				if (key === "sender_phone" && validateTelephone(form[key])) {
					error = [...error, "sender_phone_fail"];
				}

				if (
					key === "sender_email" &&
					!/^(|(([A-Za-z0-9А-Яа-я]+_+)|([A-Za-z0-9]+-+)|([A-Za-z0-9А-Яа-я]+\.+)|([A-Za-z0-9А-Яа-я]+\++))*[A-Za-z0-9А-Яа-я]+@((\w+-+)|(\w+\.))*\w{1,63}\.[a-zA-ZА-Яа-я]{2,20})$/i.test(
						form[key]
					)
				) {
					error = [...error, "sender_email_fail"];
				}
			}
		});
		this.setState({
			error,
			pdErrors: null,
		});

		if (error.length === 0) {
			func(form);
		}
	};

	// TODO: используется за компонентом
	// eslint-disable-next-line react/no-unused-class-component-methods
	show = (personal?: boolean, comment?: boolean, title?: string) => {
		this.setState({
			open: true,
			modal: {
				personal,
				comment,
			},
			title,
		});
	};

	onChange = (field: string) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		this.setState((prevState) => ({ ...prevState, form: { ...prevState.form, [field]: event.target.value } }));
	};

	render() {
		const { open, title, form, error, modal, pdErrors } = this.state;
		const { comment, sender_name, sender_email, sender_position, sender_phone, accept } = form;
		const { data, isFetching } = this.props;
		const {
			userRole,
			status,
			extRules: { ActionsRules },
		} = data;

		return (
			// @ts-ignore
			<Modal isOpen={open} ariaHideApp={false} className="react-bs-insert-modal modal-dialog" contentLabel="Modal">
				<div className="modal-content react-bs-table-insert-modal">
					<div className="modal-header">
						<button type="button" className="close" onClick={this.onClose}>
							<span aria-hidden="true">×</span>
						</button>
						<h4 className="modal-title">{title}</h4>
					</div>
					<div className="modal-body">
						{modal.comment && (
							<div className="form-group row">
								{(modal.personal || ActionsRules?.[userRole]?.[status]?.commentTitle) && (
									<div className="col-xs-12 control-label">
										<div className="reportbox-content-desc required">
											{ActionsRules[userRole][status].commentTitle || "Комментарий"}
										</div>
									</div>
								)}
								<div className="col-xs-12">
									{userRole === "user" && status === 18 && (
										<div className="alert alert-info hint">Минимум 50 символов</div>
									)}
									<textarea className="form-control" onChange={this.onChange("comment")} value={comment || ""} />
									<div className="input-counter">
										{comment &&
											50 - comment.length >= 0 &&
											`Всего: ${comment ? comment.length : 0} (Не хватает: ${50 - comment.length})`}
										{!comment && `Всего: 0`}
									</div>
									{pdErrors?.comment && <DrawErrors fields={pdErrors?.comment} />}
									{error.includes("comment") && <Alert>Поле обязательное для заполнения</Alert>}
									{error.includes("comment-minlength") && <Alert>{Errors.MIN_LENGTH.ru}</Alert>}
								</div>
							</div>
						)}
						{modal.personal && (
							<>
								<div className="form-group row">
									<div className="col-xs-12 control-label">
										<div className="reportbox-content-desc required">ФИО представителя компании</div>
									</div>
									<div className="col-xs-12">
										<div className="input-group">
											<input
												className="form-control"
												value={sender_name || ""}
												onChange={this.onChange("sender_name")}
											/>
										</div>
										{pdErrors?.pd_name && <DrawErrors fields={pdErrors?.pd_name} />}
										{error.includes("sender_name") && <Alert>Поле обязательное для заполнения</Alert>}
									</div>
								</div>
								<div className="form-group row">
									<div className="col-xs-12 control-label">
										<div className="reportbox-content-desc required">E-mail</div>
									</div>
									<div className="col-xs-12">
										<div className="input-group">
											<input
												className="form-control"
												value={sender_email || ""}
												onChange={this.onChange("sender_email")}
											/>
										</div>
										{pdErrors?.pd_email && <DrawErrors fields={pdErrors?.pd_email} />}
										{error.includes("sender_email") && <Alert>Поле обязательное для заполнения</Alert>}
										{error.includes("sender_email_fail") && <Alert>{Errors.NOT_EMAIL.ru}</Alert>}
									</div>
								</div>
								<div className="form-group row">
									<div className="col-xs-12 control-label">
										<div className="reportbox-content-desc required">Должность</div>
									</div>
									<div className="col-xs-12">
										<div className="input-group">
											<input
												className="form-control"
												value={sender_position || ""}
												onChange={this.onChange("sender_position")}
											/>
										</div>
										{pdErrors?.pd_position && <DrawErrors fields={pdErrors?.pd_position} />}
										{error.includes("sender_position") && <Alert>Поле обязательное для заполнения</Alert>}
									</div>
								</div>
								<div className="form-group row">
									<div className="col-xs-12 control-label">
										<div className="reportbox-content-desc required">Телефон</div>
									</div>
									<div className="col-xs-12">
										<div className="input-group">
											<PhoneInput
												autoFormat
												country="ru"
												onlyCountries={COUNTRIES_CODE}
												value={sender_phone || ""}
												onChange={this.setPhoneState("sender_phone")}
											/>
										</div>
										{pdErrors?.pd_phone && <DrawErrors fields={pdErrors?.pd_phone} />}
										{error.indexOf("sender_phone") > -1 && <Alert>Поле обязательное для заполнения</Alert>}
										{error.indexOf("sender_phone_fail") > -1 && <Alert>{Errors.WRONG_PHONE.ru}</Alert>}
									</div>
								</div>
							</>
						)}
						{modal.personal && (
							<div className="form-group row">
								<div className="col-xs-12 control-label">
									<div className="reportbox-content-desc required">
										<a
											href="https://lk.uat.sk.ru/actualize/static/files/agreement.pdf"
											target="_blank"
											rel="noreferrer"
										>
											Согласие на обработку персональных данных
										</a>
									</div>
								</div>
								<div className="col-xs-12">
									<div className="input-group">
										<label className="checkset-inline">
											<input
												type="checkbox"
												checked={accept}
												onChange={(_) =>
													this.setState({
														form: {
															...form,
															accept: !accept,
														},
													})
												}
											/>
											<span>Я согласен на обработку персональных данных</span>
										</label>
									</div>
									{error.includes("accept") && <Alert>Поле обязательное для заполнения</Alert>}
								</div>
							</div>
						)}
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-primary" onClick={this.onOK} disabled={isFetching}>
							Ок
						</button>
						<button type="button" className="btn btn-default btn-secondary" onClick={this.onClose}>
							Отмена
						</button>
					</div>
				</div>
			</Modal>
		);
	}
}

export default CommentModal;
